/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const accessCode = (currentUser as any)?.access ?? currentUser?.user?.access;
  const partnerId = currentUser?.partner?.id;
  const isDev = process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'dev';

  return {
    canAdmin: Boolean(currentUser) && accessCode === 'admin',
    // Payment UI is gated in production. In local dev, allow access for easier debugging.
    canAccessPayment: isDev ? true : partnerId === 7,
  };
}
